import actionTypes from '../constants/action-types';

const supportedBlockCategoriesForRegeneration = (state = [], action) => {
  if (action.type !== actionTypes.SET_SUPPORTED_BLOCK_CATEGORIES_FOR_REGENERATION) return state;
  return action.payload.categories;
};

export default supportedBlockCategoriesForRegeneration;
